import Vue from 'vue'
import VueRouter from 'vue-router'

import Basics from '../views/Basics.vue'
import Login from '../views/Login.vue'

import Home from '../views/Home.vue'


//-------------------------------------系统设置------------------------------------------
// 公司管理
import Company from '../views/system/Company.vue'
// 员工管理
import Staff from '../views/system/Staff.vue'

//-------------------------------------电梯管理------------------------------------------
// 电梯列表
import Elevator from '../views/elevator/Elevator.vue'
// 维修记录
import Repair from '../views/elevator/Repair.vue'

//-------------------------------------业务办理------------------------------------------
// 电梯卡管理
import Card from '../views/transaction/Card.vue'
// 设备操控
import Control from '../views/transaction/Control.vue'

//-------------------------------------运行数据------------------------------------------
// 刷卡记录
import Swipe from '../views/record/Swipe.vue'
// 设备操控
import Statistics from '../views/record/Statistics.vue'



Vue.use(VueRouter)

const routes = [
	{ path: '/Login', name: 'Login', component: Login },
	{ path: '/', redirect: '/Login'},
	{ 
		path: '/Basics',
		name: 'Basics',
		component: Basics,
		children: [
			{ path: '/Home', name: 'Home', component: Home },
			
			{ path: '/Company', name: 'Company', component: Company },
			{ path: '/Staff', name: 'Staff', component: Staff },
			
			{ path: '/Elevator', name: 'Elevator', component: Elevator },
			{ path: '/Repair', name: 'Repair', component: Repair },
			
			{ path: '/Card', name: 'Card', component: Card },
			{ path: '/Control', name: 'Control', component: Control },
			
			{ path: '/Swipe', name: 'Swipe', component: Swipe },
			{ path: '/Statistics', name: 'Statistics', component: Statistics },
			
			
		]
	}

]

const router = new VueRouter({
	mode: 'hash',
	base: process.env.BASE_URL,
	routes
})

export default router
